<template>
	<div class="footer">
        <!-- <div class="rule">
            <p>Copyright©2013-2017,dingfangyi.com.All rights reserved.<a href="http://beian.miit.gov.cn" class="rule-a" target="_blank">粤ICP备17131089号</a>   粤公网安备 44030302000423号</p>
        </div> -->
      
    </div>
</template>
<script>
export default {
	data() {
		return {
			
		}
	},
	methods: {
		

	}
}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue